import axios from 'axios'


/**
 *
 * @status no delete (needed for notification service when implemented)
 * @class NotificationSocket
 */
class NotificationSocket {
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    async getNotificationSocket(userId, timezone, token) {
        let response = await axios.get(`${this.apiUrl}/notifications-socket?userId=${userId}&timezone=${encodeURIComponent(timezone)}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data.data
    }

    async updateNotificationSocket(notificationActionId, notificationId, notificationParams, token) {
        let response = await axios.post(
            `${this.apiUrl}/notification-engine`,
            {
                notificationActionId,
                notificationId,
                notificationParams
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    }

    /**
     * @author Antonio Vazquez
     * @description Update pin status of a notification
     * @createdDate 30-12-25
     * @param {String} notificationId
     * @param {String} token
     * @returns {Object}
     * @memberof NotificationSocket
     */
    async putPinNotification(notificationId, status, token) {
        try {
            let response = await axios.put(
                `${this.apiUrl}/notification-pin`,
                {
                    notificationId,
                    status
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );
            return response.data
        } catch (e) {
            console.error('Error updating pin notification:', e)
        }
    }

    /**
     * @author Antonio Vazquez
     * @description Update pin status of a notification
     * @createdDate 30-12-25
     * @param {String} notificationId
     * @param {String} token
     * @returns {Object}
     * @memberof NotificationSocket
     */
    async putDisableNotification(notificationId, conversationId, token) {
        try {
            let response = await axios.put(
                `${this.apiUrl}/disable-notification`,
                {
                    notificationId,
                    conversationId
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );
            return response.data
        } catch (e) {
            console.error('Error updating pin notification:', e)
        }
    }

    /**
     * @author Antonio Vazquez
     * @descirption Attend conversation
     * @createdDate 06-01-26
     * @param {*} conversationId
     * @param {*} userId
     * @return {void}
     * @memberof NotificationSocket
     */
    async postAssistChat(conversationId, userId, token) {
        try {
            const response = await axios.post(
                `${this.apiUrl}/assist-chat`,
                {
                    conversationId,
                    userId
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            )
            return response.data.data
        } catch (e) {
            console.error(`An error occurred in postAssistChat: ${e.message}`)
        }
    }
}

export { NotificationSocket as default } 